export type PasswordStrength = 'weak' | 'medium' | 'strong';

const CHARACTER_CLASS_PATTERNS = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];

function countCharacterClasses(password: string): number {
  return CHARACTER_CLASS_PATTERNS.filter((pattern) => pattern.test(password)).length;
}

/**
 * Heuristique simple, volontairement sans librairie tierce (pas de zxcvbn) — un
 * indicateur visuel pour guider l'utilisateur, PAS une politique de sécurité : la
 * seule règle réellement appliquée est côté backend (8 caractères minimum, voir
 * apps/api/src/lib/password.ts#isPasswordLongEnough) et reste la source de vérité.
 *
 * Combine longueur et variété de classes de caractères (minuscules/majuscules/
 * chiffres/symboles) :
 *   - weak   : moins de 8 caractères, OU moins de 3 classes représentées
 *   - strong : au moins 12 caractères ET les 4 classes représentées
 *   - medium : tout le reste (cas intermédiaire)
 */
export function estimatePasswordStrength(password: string): PasswordStrength {
  if (password.length < 8) return 'weak';

  const classes = countCharacterClasses(password);
  if (classes < 3) return 'weak';
  if (password.length >= 12 && classes === 4) return 'strong';
  return 'medium';
}
